import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import { Button, Result } from 'antd';
import {Link} from "react-router-dom";
import {getURL} from "./client";

const NotFound = ()=>{
    return <><SiteHeader headerType="create-account"/><Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={<Link key="verify-sign-in" to={getURL("/")}>
                    <Button type="primary" className="login-form-button">Back home</Button>
               </Link>}
    /><SiteFooter/>
    </>
}
export default NotFound;